"use client";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import type React from "react";

interface DeleteConfirmDialogProps {
	open: boolean;
	title: string;
	onConfirm: () => void;
	onCancel: () => void;
}

export default function DeleteConfirmDialog({
	open,
	title,
	onConfirm,
	onCancel,
}: DeleteConfirmDialogProps): React.ReactElement {
	return (
		<Dialog open={open} onClose={onCancel}>
			<DialogTitle>削除確認</DialogTitle>
			<DialogContent>
				<DialogContentText>
					「{title}」を削除してもよろしいですか？
					<br />
					この操作は取り消せません。
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel} color="primary">
					キャンセル
				</Button>
				<Button onClick={onConfirm} color="error" variant="contained" autoFocus>
					削除
				</Button>
			</DialogActions>
		</Dialog>
	);
}
